module.exports = __webpack_public_path__ + "static/media/Ashvitha.5deedb36.jpg";